import { Contract, ContractFactory } from 'ethers';
import ReactGA from 'react-ga4';

import TokenDetails from "./TokenDetails";
import SimpleTokenBinaryURL from '../Assets/SimpleToken.bin';
import SimpleTokenABIURL from '../Assets/SimpleToken.abi';

class EVMTokenAPI {
    #session;
    static MAX_TOKEN_SUPPLY = BigInt((2n ** 256n) - 1n); // 2^256 - 1

    constructor(session) {
        this.#session = session;
    };

    async createToken(name, maxSupply, precision, symbol) {
        const contractByteCode = await (await fetch(SimpleTokenBinaryURL)).text();
        const contractABI = await (await fetch(SimpleTokenABIURL)).text();
        const signer = await this.#session.provider.getSigner();
        const factory = new ContractFactory(contractABI, contractByteCode, signer);
        const contract = await factory.deploy(this.#session.address, name, maxSupply, precision, symbol);

        await contract.waitForDeployment();
        ReactGA.event('evm_token_created', {'contract': contract.target});

        return {
            trxHash: contract.deploymentTransaction().hash,
            contractAddress: contract.target
        }
    };

    async issueToken(units, token) {
        const contractABI = await (await fetch(SimpleTokenABIURL)).text();
        const signer = await this.#session.provider.getSigner();
        const tokenContract = new Contract(token.contractAddress, contractABI, signer);
        const result = await tokenContract.mint(this.#session.address, units);
        return result.hash;
    };

    async fetchTokenDetails(contractAddress) {
        const contractABI = await (await fetch(SimpleTokenABIURL)).text();
        const tokenContract = new Contract(contractAddress, contractABI, this.#session.provider);
        
        const name = await tokenContract.name();
        const symbol = await tokenContract.symbol();
        const precision = await tokenContract.decimals();
        const currentSupply = await tokenContract.totalSupply();
        let maxSupply;

        try {
            maxSupply = await tokenContract.cap();
        }
        catch (error) {
            // Ignore errors from `cap` as we also need to support standard
            // ERC20 tokens, which might not have these properties available
            // and so querying them will fail
        }

        return new TokenDetails({name, maxSupply, currentSupply, precision, symbol, contractAddress});
    }
}

export default EVMTokenAPI;
